import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { SALEURI_IMG } from "@/data/content";

export default function Packaging() {
  return (
    <section data-testid="packaging-section" className="section-pad bg-surface-2/40 border-y border-border">
      <div className="max-w-7xl mx-auto container-px grid lg:grid-cols-12 gap-12 items-center">
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="lg:col-span-6 order-2 lg:order-1"
        >
          <p className="eyebrow mb-4">Produs real DOTAPAN</p>
          <h2 className="h-display text-3xl md:text-5xl text-text">
            Pregătite pentru raft, vitrină <br />
            <em className="text-gold not-italic">și servire rapidă.</em>
          </h2>
          <p className="mt-6 text-base md:text-lg text-text-soft leading-relaxed">
            Pe lângă gust, contează și prezentarea. Produsele DOTAPAN sunt gândite pentru afaceri care au nevoie de soluții
            curate, practice și ușor de vândut.
          </p>

          <div className="mt-8 card-soft p-6">
            <p className="eyebrow mb-2">Exemplu</p>
            <h3 className="font-display text-2xl text-text">Saleuri cu chimen</h3>
            <p className="mt-2 text-sm md:text-base text-text-soft leading-relaxed">
              Ambalate, practice, gustoase și potrivite pentru retail, evenimente sau servire rapidă. Format 140g.
            </p>
            <Link to="/contact" className="mt-5 inline-block">
              <Button className="btn-gold rounded-full h-11 px-6" data-testid="packaging-cta">
                Cere oferta pentru retail
              </Button>
            </Link>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="lg:col-span-6 order-1 lg:order-2"
        >
          <div className="relative rounded-3xl overflow-hidden border border-border bg-white">
            <img src={SALEURI_IMG} alt="Saleuri cu chimen ambalate" className="w-full h-[520px] object-contain bg-white" />
          </div>
        </motion.div>
      </div>
    </section>
  );
}
